module.exports = "/images/la.svg?2438ae799209a0ab0adceda3831bf510";